import { scrollToTop } from "@homeinstead/shared";
import { useEffect } from "react";
import DecorativeStars from "../../Icons/animations/DecorativeStars";
import SpinningStar from "../../Icons/animations/SpinningStars";

const ThankYou = ({ firstName }: { firstName: string }) => {
  useEffect(() => {
    // just ensures the thank you page is scrolled to the top
    scrollToTop();
  }, []);

  return (
    <div className="flex w-full flex-col items-center gap-4 px-8 font-jakarta text-new-beginnings-base sm:px-12">
      <div className="relative mt-4">
        <SpinningStar />
        <DecorativeStars />
      </div>
      <h1 className="text-center font-editorial-new font-light text-1xl xl:text-left">
        We&apos;ve received your details, {firstName}.
      </h1>
      <p className={"mb-4 max-w-xl text-md leading-relaxed"}>
        A care team member from your local Home Instead® office will be getting
        in touch with you shortly.
      </p>

      <p className={"mb-8 max-w-xl text-md leading-relaxed"}>
        Our home care plans are meant to ensure both comfort and safety. If your
        needs change, our care plans can be adjusted accordingly.
      </p>
    </div>
  );
};

export default ThankYou;
